import { Flat } from "@mgi-labs/preview";

const whiteBloomFlat: Flat = new Flat({
  name: "WhiteBloom",
  paper: {
    layer: { url: "BlackSatin.png", name: "paper" },
  },
  design: {
    recto: {
      color: {
        layer: {
          url: "color.png",
          url_SD: "color.png",
          name: "color",
          width: 1512,
          height: 2048,
        },
      },
      goldFoil: {
        layer: {
          url: "goldFoil.png",
          url_SD: "goldFoil.png",
          name: "Foil Gold",
        },
      },
      silverFoil: {
        layer: {
          url: "silverFoil.png",
          url_SD: "silverFoil.png",
          name: "Foil Silver",
        },
      },
      varnish: {
        layer: { url: "varnish.png", url_SD: "varnish.png", name: "Varnish" },
      },
    },
    mask: {
      url: "mask.png",
      width: 850,
      height: 1153,
    },
  },
});

export default whiteBloomFlat;
